import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import styled from 'styled-components'
import GenericModal from '../../GenericModal'
import { connect } from 'react-redux'
import classNames from 'classnames';
import employeeService from '../../../services/Employee.service'
import {UserRoles} from '../../../constants'


const Content = styled.div`

  padding: 16px 20px 17px 20px;

  h3 {
    font-family: Lato-Regular;
    font-size: 12px;
    font-weight: bold;

    color: #666666;
    line-height: 16px;
    margin: 0px;
    padding: 0px;
  }

  p {
    font-family: Lato-Regular;
    font-size: 14px;
    color: #2B2B2B;
    line-height: 22px;
    margin: 0px;
    padding: 0px;
    margin-top: 6px;
  }

  div.sell-for-taxes {
    font-family: Lato-Regular;
    font-size: 14px;
    color: #2B2B2B;
    line-height: 22px;
    margin: 0px;
    padding: 0px;
    margin-top: 6px;
  }

  .current-method {
    color: #666666;
    background: #EDEDED;
    padding: 11px 16px;
    margin-top: 9px;
    display: block;
  }

  .anchor-inline {
    display: inline;
  }

  > button {
    height: 43px;
    width: 100%;
    margin-top: 15px;
  }

  a {
    font-family: Lato-Regular;
    font-size: 14px;
    color: #1D71BB;
    line-height: 16px;
    text-decoration: none;
    margin-top: 7px;
    display: block;
  }

  .disableClick{
      pointer-events: none;
      color: #BBBBBB;
  }
`

export class VestElectionsDialog extends Component {

  onChangeDeliveryMethod = (callback) => {
    this.props.onChangeDeliveryMethod()
  }

  onChangeTaxPaymentBroker = () => {
    var brokerUrl = employeeService.getEmployeeBrokerUrl(this.props.employee)

    if(this.props.employee.broker && brokerUrl && this.props.employee.broker !== '') {
      var win = window.open(brokerUrl, '_blank');
      win.focus();
      this.props.onCloseDialog()
    }
  }

  isOption(awards, awardId){
    if (awards && awardId){
      var award = employeeService.loadAward(this.props.employee.awards, awardId)
      return award ? employeeService.isOption(award) : false
    }
    else {
      return false;
    }
  }

  render() {
    
    if (!this.props.visible) {
      return null;
    }

    const { t, employee, awardIdSelected, calendarYear, vest } = this.props;

    var fractionalEnable = this.props.fractional_mode && !this.isOption(employee.awards, awardIdSelected) && employeeService.hasFractionalEligibleVest(employee);

    let methods = ''

    if (vest) {
      methods = t(`TaxTreatment.${vest.tax_election.code}`)
    } else {
      methods = employeeService.getPaymentMethods(employee.awards, awardIdSelected, calendarYear)
        .map(taxElectionCode => t(`TaxTreatment.${taxElectionCode}`))
        .join(', ')
    }

    let excessMethod = employeeService.getVestFractionalElectionText(t, employee, vest)

    let taxElectionsEmail = t('VestElectionsDialog.TaxElectionEmailNoAPS')
    if (employeeService.isZooxEmployee(employee)){
      taxElectionsEmail = t('VestElectionsDialog.TaxElectionEmailZoox')
    }

    return (
      <GenericModal
        title={t('VestElectionsDialog.Title')}
        visible={this.props.visible}
        onCloseDialog={this.props.onCloseDialog}
        width={380}
        className="tax-elections"
      >
        <Content>
          <h3>{t('VestElectionsDialog.TaxPaymentMethod')}</h3>
          <p>{t('VestElectionsDialog.AvailableMethods')}</p>
          <div className="sell-for-taxes">
            <ul>
              <li>{t(`TaxTreatment.0`)}&nbsp;{t('VestElectionsDialog.DefaultLabel')}</li>
              <li>{t(`TaxTreatment.1`)}</li>
              <li>{t(`TaxTreatment.2`)}</li>
            </ul>
          </div>

          {  !employeeService.isBrokerChoiceNone(employee) &&
            <React.Fragment>
              {  !employeeService.isAPSEmployee(employee) &&
                <div>
                  <a href="#" className='anchor-inline' target='_blank' onClick={this.onChangeTaxPaymentBroker}>{t('VestElectionsDialog.ChangeTax')}</a>
                  <p className="current-method">{t('VestElectionsDialog.CurrentMethod')}: {methods}</p>
                  <p dangerouslySetInnerHTML={{ __html: t('VestElectionsDialog.TaxElectionMessageNoAPS') }}></p>
                  <p dangerouslySetInnerHTML={{ __html: taxElectionsEmail }}></p>
                </div>
              }
              {  employeeService.isAPSEmployee(employee) &&
                <div>
                  <a href="#" className='anchor-inline' target='_blank' onClick={this.onChangeTaxPaymentBroker}>{t('VestElectionsDialog.ChangeTax')}</a>
                  <p className="current-method">{t('VestElectionsDialog.CurrentMethod')}: {methods}</p>
                  { employeeService.showTaxElectionMessage(employee) &&
                    <p dangerouslySetInnerHTML={{ __html: t('VestElectionsDialog.TaxElectionMessage') }}></p>
                  }
                </div>
              }
            </React.Fragment>
          }
          <br/>
          <p dangerouslySetInnerHTML={{ __html: t('VestElectionsDialog.SeeDetail') }}></p>

          { fractionalEnable &&
            <div>
              <br/>
              <hr/>
              <h3>{t('VestElectionsDialog.FractionalShareElection')}</h3>
              <p>{t('VestElectionsDialog.IfElected')}</p>
              <div className="sell-for-taxes">
                <ul>
                  <li dangerouslySetInnerHTML={{ __html: t(`VestElectionsDialog.SellForTaxesCash`) }}></li>
                  <li dangerouslySetInnerHTML={{ __html: t(`VestElectionsDialog.SellForTaxesFractional`) }}></li>
                </ul>
              </div>
              <button className="primary-button change-delivery" onClick={this.onChangeDeliveryMethod}>{t('VestElectionsDialog.ChangeDeliveryMethod')}</button>
              <p className="current-method">{t('VestElectionsDialog.CurrentMethod')}: {excessMethod}</p>
            </div>
          }
        </Content>
      </GenericModal>
    )
  }
}

const mapState = state => ({
  employee: state.employee,
  fractional_mode: state.static_content.fractional_mode
})

export default connect(mapState)(withTranslation('translations')(VestElectionsDialog))

